import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PromocionesService } from '../../services/promociones.service';

@Component({
  selector: 'app-promo-oficina-form',
  templateUrl: './promo-oficina-form.component.html',
  styleUrls: ['./promo-oficina-form.component.css']
})
export class PromoOficinaFormComponent implements OnInit {

  agregarFormCondOficinaVenta!: FormGroup;
  cmbOficinaVenta = [];

  @Input()
  set idPromo(id: string) {
    this.agregarFormCondOficinaVenta.get('id_promo').setValue(id);
  }

  @Input()
  idOficinas: string[];

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly promocionesService: PromocionesService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.cargarCondOficinaVenta();
  }

  private buildForm() {
    this.agregarFormCondOficinaVenta = this.formBuilder.group({
      id_promo: ['', []],
      id_oficina_venta: ['', [Validators.required]]
    })
  }

  cargarCondOficinaVenta() {
    this.promocionesService.oficinaVenta().subscribe(
      (resp) => {
        if (resp) {
          this.cmbOficinaVenta = resp.filter((item) => !this.idOficinas.includes(item.idOficinaVenta));
        } else {
          this.cmbOficinaVenta = [];
        }
      },
      (error) => {
        this.cmbOficinaVenta = [];
      }
    );
  }

  accionesCondOficinaVenta(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormCondOficinaVenta.getRawValue());
    } else {
      this.back.emit();
    }
  }

}
